<div class="flag-icon" title="{{ (flagState ? 'flag.removeFlag' : 'flag.flag') | translate }}">
  <svg-icon
    *ngIf="!isFlagStateChanging"
    icon="{{ flagState ? 'flag-filled' : 'flag-empty' }}"
    class="flag-icon-inner"
    (click)="setFlag($event)">
  </svg-icon>
  <svg-icon *ngIf="isFlagStateChanging" class="svg-icon-spin flag-loading" icon="refresh"></svg-icon>
</div>
